var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#604bc4;stroke-width:2px;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-994 -1652)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.5,7h7a3.5,3.5,0,0,0,0-7h-4l.072,14",
    transform: "translate(988.5 1669)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 6,
    transform: "translate(1010 1679)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1000 1660)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 15,
    cy: 15,
    r: 14
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(995 1655)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3.5,
    cy: 3.5,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(994 1687)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3.5,
    cy: 3.5,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1027 1652)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 5,
    cy: 5,
    r: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1025 1688)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 6,
    cy: 6,
    r: 5
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,2,7,7",
    transform: "translate(998.5 1658.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,2,7,7",
    transform: "translate(1021.5 1683.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,3,10,7",
    transform: "translate(1014.5 1657.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,2,10,7",
    transform: "translate(989.5 1681.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubIcon);
export default __webpack_public_path__ + "static/media/rub-icon.e1f0a15cfebea2698155855336db05be.svg";
export { ForwardRef as ReactComponent };